export const FORCE_RENDER_HASH = 'rdrx-forceEpubRender';

/**
 * Special hash identifier used to force the entire iFrame to rerender.
 */
export const FORCE_REFRESH_HASH = 'rdrx-forceRefresh';
